import React, { useState, useEffect } from 'react';
import {
    useParams,
  } from "react-router-dom";
import '../../App.css';
import UserAdminControls from './UserAdminControls';


const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];


export default function UserAccount({ sessionData, setSessionData }) {
    let [data, setData] = useState();
    let [stats, setStats] = useState();
    let { username } = useParams();

    useEffect(() => {
        const url = "https://api.board.dylang140.com/userPublic";
        let sendData = {username: username};

        const fetchData = async () => {
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)
                    })
                const json = await response.json();
                setData(json.user);
                console.log(json.stats);
                setStats(json.stats);
            } catch (error) {
                console.log("error", error);
            }
        };

        fetchData();
    }, []);

    if(data?.username){
        let dateCreated = new Date(data.date_created|| "");
        let dateLogged = new Date(data.date_last_logged_in|| "");
        if(dateCreated !== "") {
            dateCreated.setHours(dateCreated.getHours() - 10);
            dateCreated = months[dateCreated.getMonth()] + " " + dateCreated.getDate() + ", " + dateCreated.getFullYear();
        }
        if(dateLogged !== "") {
            //dateLogged.setHours(dateLogged.getHours() - 10);
            dateLogged = months[dateLogged.getMonth()] + " " + dateLogged.getDate() + ", " + dateLogged.getFullYear() + " at "
                + (dateLogged.getHours() > 12 ? dateLogged.getHours() - 12 : dateLogged.getHours()) + ":" + dateLogged.getMinutes() 
                + (dateLogged.getHours() > 12 ? " PM" : " AM");
        }
        let pfp = (
            data?.imageURL && data?.imageURL !== "" ? 
            <img className="pfpBig" src={"https://api.board.dylang140.com/" + data?.imageURL} /> : 
            <img className="pfpBig" src="../pfp_default.png" />
        );
        return (
            <div className='Page'>
                <table><tbody><tr>
                    <td>
                        {pfp}
                    </td>
                    <td>
                        <h1>&nbsp;
                            <span className="DataListItem" style={{"color": '#' + data.displayNameHex}}>
                                {data.displayName || ""}
                            </span>
                        </h1>
                    </td>
                </tr></tbody></table>
                <h2>Username</h2>
                {data?.username}
                <a href={"/userPosts/" + data?.username}><h3>View {data?.username}'s posts</h3></a>
                <h2>About</h2>
                <p className='textBlock showBreaks'>{data?.user_bio}</p>
                <h2>
                    Joined
                </h2>
                {dateCreated}
                <h2>
                    Last Seen
                </h2>
                {dateLogged}
                <h2>User Stats</h2>
                <table>
                    <tbody>
                        <tr>
                            <td>Posts </td>
                            <td> <b>{stats.postCount}</b></td>
                        </tr>
                        <tr>
                            <td>Comments </td>
                            <td> <b>{stats.commentCount}</b></td>
                        </tr>
                        <tr>
                            <td>Likes </td>
                            <td> <b>{stats.likeCount}</b></td>
                        </tr>
                    </tbody>
                </table>

                <br/><br/>
                <UserAdminControls sessionData={sessionData} setSessionData={setSessionData} username={data.username}/>

            </div>
        )
        return(
            <div className="Page">
                <h2>{username}</h2>
                <table className="DataList">
                    <tbdoby>
                        <tr className="DataList">
                            <td><i><p className="DataListItem">Username:</p></i></td>
                            <td><p className="DataListItem">{data.username || ""}</p></td>
                        </tr>
                        <tr className="DataList">
                            <td><i><p className="DataListItem">Display Name:</p></i></td>
                            <td><p className="DataListItem" style={{"color": '#' + data.displayNameHex}}>{data.displayName || ""}</p></td>
                        </tr>
                        <tr className="DataList">
                            <td><i><p className="DataListItem">Profile Picture:</p></i></td>
                            <td> 
                                {pfp}
                            </td>
                        </tr>
                        <tr className="DataList">
                            <td><i><p className="DataListItem">Bio:</p></i></td>
                            <td><p className="DataListItem showBreaks">{data.user_bio || ""}</p></td>
                        </tr>
                        <tr className="DataList">
                            <td><i><p className="DataListItem">Last Seen:</p></i></td>
                            <td><p className="DataListItem">{dateLogged || ""}</p></td>
                        </tr>
                        <tr className="DataList">
                            <td><i><p className="DataListItem">Date Joined:</p></i></td>
                            <td><p className="DataListItem">{dateCreated || ""}</p></td>
                        </tr>
                        <tr className="DataList">
                            <td><i><p className="DataListItem">Administrator:</p></i></td>
                            <td><p className="DataListItem">{data.administrator ? "Yes" : "No"}</p></td>
                        </tr>
                    </tbdoby>
                </table>
            </div>
        );
    }
    return (
        <div className="Page">
            <h2>This user does not exist!</h2>
        </div>
    )
}

